import { Chart } from "react-google-charts";

export const options = {
    colors: ["#0c2074"],
};

export const LogUsageChart = ({data}) => {
    return (
        <Chart
            chartType="Bar"
            width="100%"
            height="400px"
            data={data || [["Date", "Usage"]]}
            options={options}
        />
    )
};